module.exports = __webpack_public_path__ + "static/media/nothingbutsafes.8991ae73.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/nothingbutsafes.png
// module id = 1150
// module chunks = 0